import { getApiHost } from '../utils/getApiHost';

export default [
    '$http',
    '$interval',
    'auth',
    function ($http, $interval, auth) {
        let migrateStatusPollPromise = null;

        const MIGRATE_STATUS_POLL_INTERVAL_MS = 30000;
        const MIGRATION_STATUS = {
            MIGRATED: 'MIGRATED',
            MIGRATING: 'MIGRATING',
        };

        function stopPolling() {
            if (migrateStatusPollPromise) {
                $interval.cancel(migrateStatusPollPromise);
                migrateStatusPollPromise = null;
            }
        }

        function getMigrationStatus(response) {
            return response?.data?.data?.status;
        }

        function checkStatus(token = auth.authToken()) {
            return $http
                .get(new URL('/v2/directory/~migrate/status', getApiHost()).toString())
                .then((response) => getMigrationStatus(response))
                .catch((err) => {
                    if (token === auth.authToken() && err?.status >= 400) {
                        stopPolling();
                    }
                    return undefined;
                });
        }

        function startPolling(onStatusChanged, pollImmediately = false) {
            stopPolling();

            let lastReportedValue;

            function notify(status, token) {
                if (!status) {
                    return;
                }

                const isMigrated = status === MIGRATION_STATUS.MIGRATED;

                if (
                    onStatusChanged &&
                    token === auth.authToken() &&
                    isMigrated !== lastReportedValue
                ) {
                    lastReportedValue = isMigrated;
                    onStatusChanged(isMigrated);
                }
            }

            function handleStatus(status, token) {
                notify(status, token);

                if (token !== auth.authToken() || !status) {
                    return;
                }

                if (status === MIGRATION_STATUS.MIGRATING) {
                    startInterval();
                } else {
                    stopPolling();
                }
            }

            function startInterval() {
                if (!migrateStatusPollPromise) {
                    migrateStatusPollPromise = $interval(
                        checkAndHandleStatus,
                        MIGRATE_STATUS_POLL_INTERVAL_MS
                    );
                }
            }

            function checkAndHandleStatus() {
                const token = auth.authToken();
                checkStatus(token).then((status) => {
                    handleStatus(status, token);
                });
            }

            if (pollImmediately) {
                startInterval();
            }

            checkAndHandleStatus();

            return stopPolling;
        }

        return {
            startPolling,
            stopPolling,
            checkStatus,
        };
    },
];
